import Footer3 from '@ff/ui/Footer3';

export default Footer3;
